/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

NodeList.prototype.addEventListener = function(eventType, callback, useCapture) {
  this.forEach(function(node) {
    node.addEventListener(eventType, callback, useCapture);
  });
};

function cleanSearch() {
  if (location.search.length > 0) {
    var searchParams = ['_pos=', '_psq=', '_fid', '_sid', '_ss=', '_v=', 'pr_prod_strat=', 'pr_rec_id=', 'pr_rec_pid=', 'pr_ref_pid=', 'pr_seq='];
    var params = location.search.slice(1).split('&').filter(function(param) {
      return !searchParams.some(function(searchParam) {
        return param.includes(searchParam);
      });
    });

    history.replaceState(null, '', location.pathname + (params.length > 0 ? '?' + params.join('&') : '') + location.hash);
  }
}

function scrollToEle(selector, offset, scrollTargetSelector) {
  var element = null;
  try {
    element = document.querySelector(selector);
  } catch (e) {
    return;
  }

  var toTop = 0;
  offset = offset || 0;
  scrollTarget = document.querySelector(scrollTargetSelector) || window;

  while (element.offsetParent && element.offsetParent.tagName !== 'BODY') {
    toTop += element.offsetTop;
    element = element.offsetParent;
  }

  toTop += element.offsetTop;
  scrollTarget.scrollTo({
    behavior: 'smooth',
    top: toTop - offset
  });
}

window.np = {
  product: {},
  practitioner: {},
  cart: {},
  deal: {}
};

/*************************
Product page
*************************/
/* Quantity Restriction */
np.product.maxQty = {
  init: function() {
    document.querySelectorAll('[data-max-quantity]:not([data-allowance])').forEach(function(block) {
      // process max quantity on product page
      var product = np.product.get(block.dataset.productId);
      if (product) {
        var processedBlock = document.querySelector(`[data-variant-id="${block.dataset.variantId}"][data-allowance]`);
        var maxQuantity = product.variants.find(function(variant) {
          return variant.id == block.dataset.variantId;
        }).maxQuantity;
        block.dataset.maxQuantity = maxQuantity;
        block.dataset.allowance = processedBlock ? processedBlock.dataset.allowance : Math.max(0, maxQuantity - np.cart.qtyInCart(block.dataset.variantId));

        var maxQuantityInfo = block.querySelector('.product-extra-info__quantity-restriction .max-quantity');
        if (maxQuantityInfo) {
          maxQuantityInfo.textContent = maxQuantity;
        }
      }

      // bind quantity selector on product page
      block.querySelectorAll('.quantity-selector__value').forEach(function(ele) {
        ['input', 'change', 'paste', 'keyup'].forEach(function(eventType) {
          ele.addEventListener(eventType, function(e) {
            var productBlock = e.currentTarget.closest('[data-allowance]');
            if (productBlock && e.currentTarget.value > productBlock.dataset.allowance) {
              e.currentTarget.value = productBlock.dataset.allowance;
            }
          });
        });
      });
      block.querySelectorAll('.quantity-selector--product').addEventListener('click', function(e) {
        if (e.target.classList.contains('quantity-selector__button')) {
          e.currentTarget.querySelector('.quantity-selector__value').dispatchEvent(new Event('input', {
            bubbles: true
          }));
        }
      });
    });
  },
  process: function(variantId, qtyAdded) {
    var blocks = Array.from(document.querySelectorAll(`[data-variant-id="${variantId}"][data-allowance]`));
    if (blocks.length > 0) {
      var qtyMax = parseInt(blocks[0].dataset.maxQuantity, 10);
      var qtyAllowance = Math.min.apply(Math, blocks.map(function(blk) {
        return blk.dataset.allowance;
      }).concat([qtyMax - np.cart.qtyInCart(variantId)]));

      qtyAllowance -= qtyAdded;
      blocks.forEach(function(blk) {
        blk.dataset.allowance = Math.max(0, qtyAllowance);
        if (blk.matches('.card')) {
          blk.querySelector('.quantity-selector__value').dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }
      });
    }
  },
  restore: function(block) {
    var variantId = parseInt(block.dataset.variantId, 10);
    var qtyMax = parseInt(block.dataset.maxQuantity, 10);
    var qtyInCart = parseInt(block.querySelector('.quantity-selector__value').value, 10) || 1;

    document.querySelectorAll(`[data-variant-id="${variantId}"]`).forEach(function(ele) {
      ele.dataset.allowance = Math.min(qtyMax, parseInt(ele.dataset.allowance, 10) + qtyInCart);
    });
    np.cart.update(variantId, qtyInCart);
  }
};

/* Consultation forms */
np.product.consultationForm = {
  init: function() {
    this.process();

    // listen to quick view modal
    var modal = document.querySelector('div[id^="modal-quick-view-template"]');
    if (modal) {
      new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (!mutation.target.classList.contains('is-loading')) {
            np.product.consultationForm.process();
          }
        });
      }).observe(modal, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  },
  process: function() {
    var consultationForm = document.querySelector('.product-consultation_form');
    if (!consultationForm) return;

    // toggle form when clicking form header
    consultationForm.querySelector('.product-consultation_form__title').addEventListener('click', function() {
      consultationForm.classList.toggle('collapsed');
      consultationForm.classList.toggle('expanded');
    });

    // toggle form when clicking toggle arrow
    document.querySelector('.product-consultation_form__toggle').addEventListener('click', function() {
      consultationForm.classList.toggle('collapsed');
      consultationForm.classList.toggle('expanded');

      // scroll to position when expand the form
      if (consultationForm.classList.contains('expanded')) {
        scrollToEle('#product-consultation_form', 20, '.modal[aria-hidden="false"] .modal__dialog');
        setTimeout(function() {
          scrollToEle('#product-consultation_form', 20, '.modal[aria-hidden="false"] .modal__dialog');
        }, 500);
      }

      // scroll up when collapse the form
      if (consultationForm.classList.contains('collapsed')) {
        scrollToEle('.product-meta', 0, '.modal[aria-hidden="false"] .modal__dialog');
      }
    });

    // insert additional file upload field
    consultationForm.querySelectorAll('.product-consultation_form__more').addEventListener('click', function() {
      var upload = consultationForm.querySelector('input[type="file"]:last-of-type');
      if (upload) {
        var newUpload = upload.cloneNode();
        newUpload.required = false;
        newUpload.name = upload.name.replace(/\d/, function(match) {
          return ++match;
        });
        newUpload.addEventListener('click', function(e) {
          var cursorX = e.pageX - newUpload.getBoundingClientRect().left + window.scrollX;

          if (cursorX > newUpload.offsetWidth - newUpload.offsetHeight) {
            e.preventDefault();
            newUpload.remove();
          }
        });
        upload.after(newUpload);
      }
    });

    // toggle sub-form
    var subForms = consultationForm.querySelectorAll('.product-consultation_form__subForm');
    if (subForms[0]) {
      subForms[0].querySelectorAll('input[type="radio"]').addEventListener('change', function(e) {
        subForms.forEach(function(subForm, index) {
          if (subForm.matches(`[data-sub-form=${e.target.dataset.subForm}]`)) {
            subForm.style.display = 'block';
            subForm.querySelectorAll('input, select, textarea').forEach(function(ele) {
              ele.disabled = false;
            });
          } else if (index !== 0) {
            subForm.style.display = 'none';
            subForm.querySelectorAll('input, select, textarea').forEach(function(ele) {
              ele.disabled = true;
            });
          }
        });
      });
    }

    // calculate age
    consultationForm.querySelectorAll('input[name="properties[BirthDay]"], select[name="properties[BirthMonth]"], input[name="properties[BirthYear]"]').addEventListener('change', function(e) {
      var div = e.target.parentElement;
      var birthDay = div.querySelector('input[name="properties[BirthDay]"]').value;
      var birthMonth = div.querySelector('select[name="properties[BirthMonth]"]').value;
      var birthYear = div.querySelector('input[name="properties[BirthYear]"]').value;

      if (birthDay > 0 && birthMonth.length && birthYear > 0) {
        try {
          var age = Math.floor((new Date() - new Date(birthYear + ' ' + birthMonth + ' ' + birthDay).getTime()) / 3.15576e+10);
          if (!age) {
            age = birthYear > 1000 ? new Date().getFullYear() - birthYear : 0;
          }
          var ageField = div.querySelector('input[name="properties[Age]"]');

          ageField.value = age;

          // check if product has age restriction
          if (ageField.hasAttribute('data-min') && ageField.dataset.min > age) {
            consultationForm.closest('form').classList.add('notEligible');
            np.popup.show('Not eligible', `This medicine is only for patients over ${ageField.dataset.min} years of age.`, 5000);
          } else {
            consultationForm.closest('form').classList.remove('notEligible');
          }
        } catch (error) {}
      }
    });

    // calculate BMI
    consultationForm.querySelectorAll('input[name="properties[Height_cm]"], input[name="properties[Weight_kg]"]').addEventListener('change', function(e) {
      var div = e.target.parentElement;
      var height = parseInt(div.querySelector('input[name="properties[Height_cm]"]').value, 10);
      var weight = parseInt(div.querySelector('input[name="properties[Weight_kg]"]').value, 10);

      if (Number.isInteger(height) && height > 100 && Number.isInteger(weight) && weight > 0) {
        var BMIField = div.querySelector('input[name="properties[BMI]"]');
        var BMI = (weight / Math.pow(height / 100, 2)).toFixed(2);

        BMIField.value = BMI;
        div.querySelector('.BMIValue').textContent = BMI;

        if (BMIField.hasAttribute('data-min') && BMIField.dataset.min > BMI) {
          consultationForm.closest('form').classList.add('notEligible');
          np.popup.show('Not eligible', `This medicine is only for adults with an initial BMI of ${BMIField.dataset.min} or more.`, 5000);
        } else {
          consultationForm.closest('form').classList.remove('notEligible');
        }
      }
    });

    // merge checkbox inputs
    consultationForm.querySelectorAll('.product-consultation_form--checkbox input[type="checkbox"]').addEventListener('change', function(e) {
      var container = e.target.closest('.product-consultation_form--checkbox');
      var input = container.querySelector('input[type="hidden"]');
      var checked = container.querySelectorAll('input[type="checkbox"]:checked');

      if (input && checked.length > 0) {
        input.value = Array.from(checked).map(function(ele) {
          return ele.value;
        }).join(', ');
      }

      // update required attribute for hidden checkbox
      if (container.dataset.required) {
        container.querySelector('.tooltip').required = !checked.length;
      }
    });

    // override add to cart button to upload consultation form
    document.querySelectorAll('.product-form__add-button').addEventListener('click', function(e) {
      e.stopImmediatePropagation();
      e.stopPropagation();
      e.preventDefault();

      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      e.currentTarget.disabled = true;

      var productForm = e.currentTarget.closest('form');

      // if not valid, trigger invalid UI
      if (!productForm.checkValidity()) {
        scrollToEle('#product-consultation_form', 20, '.modal[aria-hidden="false"] .modal__dialog');
        consultationForm.classList.remove('collapsed');
        consultationForm.classList.add('expanded');

        e.currentTarget.disabled = false;
        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        setTimeout(function() {
          scrollToEle('#product-consultation_form', 20, '.modal[aria-hidden="false"] .modal__dialog');
          productForm.reportValidity();
        }, 500);
      } else {
        productForm.submit();
      }
    });
  }
};

/* misc functions */
np.product.parse = function(dom) {
  dom.querySelectorAll('script.product-data').forEach(function(script) {
    var productId = parseInt(script.dataset.productId, 10);
    var data = JSON.parse(script.textContent.trim());

    np.product[productId] = data.product;
    np.product[productId].collections = data.collections;

    // assign max quantity
    if (np.product[productId].tags.includes('Quantity Restricted')) {
      var maxQuantities = np.product[productId].tags.join(',').split(',max-').pop().split(',').shift().split('-');

      np.product[productId].variants.forEach(function(variant, index) {
        variant.maxQuantity = parseInt(maxQuantities[index], 10);
      });
    }

    script.remove();
  });
};
np.product.get = function(arg) {
  if (!arg || typeof arg === 'undefined' || (arg && arg.length === 0)) {
    arg = '.card[data-product-id]';
  }
  if (typeof arg === 'number') {
    return np.product[arg];
  }
  if (typeof arg === 'string') {
    if (!isNaN(arg)) {
      return np.product[parseInt(arg, 10)];
    }

    var card = document.querySelector(arg);

    if (card) {
      return np.product[parseInt(card.dataset.productId, 10)];
    }
  }

  return null;
};

/*************************
Deals
*************************/
np.deal = {
  campaigns: [],
  init: function() {
    var dealData = document.querySelector('#deal-data');

    if (dealData) {
      this.campaigns = JSON.parse(dealData.textContent.trim())
        .sort(function(a, b) { // sort priority first;
          return a.priority - b.priority;
        })
        .sort(function(a, b) { // sort by group
          return a.group != b.group ? a.group.length - b.group.length : 0;
        })
        .sort(function(a, b) { // sort global priority
          b.global_priority ? 1 : 0 - a.global_priority ? 1 : 0
        });
    }
  },
  isActive: function(campaign) {
    var active = false;

    // check if campaign still valid
    var dt = new Date();
    var startDate = new Date(campaign.start_date + '.000+12:00');
    var endDate = new Date(campaign.end_date + '.000+12:00');

    if (dt > startDate && dt < endDate) {
      active = true;
    }

    // check if campaign on debug mode
    if (campaign.debug_mode) {
      active = !!document.querySelector('#PBarNextFrameWrapper');
    }

    return active;
  },
  isEligible: function(campaign, productId) {
    var eligible = false;
    var product = np.product.get(productId);
    var conditions = campaign.conditions;

    if (product) {
      if (conditions.filter_by_brand) {
        eligible = conditions.filter_by_brand.trim() === product.vendor;
      }
      if (conditions.filter_by_collection) {
        var filter_collection = conditions.filter_by_collection.trim();
        eligible = product.collections.some(function (collection) {
          return filter_collection === collection.title;
        });
      }
      if (conditions.filter_by_tags) {
        var filter_tags = conditions.filter_by_tags.split(',').filter(function(tag) {
          return tag.trim().length > 0;
        });
        eligible = filter_tags.some(function(tag) {
          return product.tags.includes(tag);
        });
      }
      if (conditions.filter_by_products) {
        var filter_products = conditions.filter_by_products.toString().trim();
        eligible = filter_products.includes(product.id.toString());
      }

      // product is eligible if all filters are empty
      if (!conditions.filter_by_brand && !conditions.filter_by_collection && !conditions.filter_by_tags && !conditions.filter_by_products) {
        eligible = true
      }

      // check exclusions if product is eligible
      if (eligible && conditions.exclude_by_brand) {
        eligible = conditions.exclude_by_brand.trim() !== product.vendor;
      }
      if (eligible && conditions.exclude_by_collection) {
        var exclude_collection = conditions.exclude_by_collection.trim();
        eligible = !product.collections.some(function (collection) {
          return exclude_collection === collection.title;
        });
      }
      if (eligible && conditions.exclude_by_tag) {
        var exclude_tags = conditions.exclude_by_tag.split(',').filter(function(tag) {
          return tag.trim().length > 0;
        });
        eligible = !exclude_tags.some(function(tag) {
          return product.tags.includes(tag);
        });
      }
      if (eligible && conditions.exclude_by_products) {
        var exclude_products = conditions.exclude_by_products.toString().trim();
        eligible = !filter_products.includes(product.id.toString());
      }
    }

    return eligible;
  },
  addGiftToCart: function(campaign, variantData) {
    if (campaign) {
      var giftItem = {
        items: [{
          id: 39434542317611,
          quantity: campaign.giftQuantity || 1,
          properties: {
            'campaign': campaign.name
          }
        }]
      };
      if (campaign.gift_variant_id) {
        giftItem.items[0].id = campaign.gift_variant_id;
      }
      if (variantData) {
        giftItem.items[0].id = variantData.id;
      }
      if (variantData && giftItem.items[0].id == 39434542317611) {
        giftItem.items[0].properties.title = variantData.name;
      }
      if (campaign.gift_title_override) {
        giftItem.items[0].properties.title = campaign.gift_title_override;
      }
      fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(giftItem)
        })
        .then(function() {
          location.reload();
        })
        .catch(function(_error) {
          console.error(_error);
        });
    }
  },
  applyToCart: function() {
    var giftBlock = document.querySelector('.gift-offer');
    var global_priority = false;
    var priority = 99;
    var group = '';
    // filter out active & eligible campaigns
    var campaigns = this.campaigns.filter(function(campaign) {
      // check campaign type
      if (campaign.type !== 'gwp') return false;
      // check is campaign active
      if (!np.deal.isActive(campaign)) return false;
      // check global priority
      if (global_priority && !campaign.global_priority) return false;
      // check campaign priority
      if (group.length > 0 && group == campaign.group && campaign.priority > priority) return false;
      // check gift item conditions then extract eligible items cart value & quantity
      var giftInCart;
      var giftQtyInCart = 0;
      var cartValue = 0;
      var cartQuantity = 0;

      np.cart.items.forEach(function(item, index) {
        if (np.deal.isEligible(campaign, item.product_id)) {
          cartValue += item.final_line_price / 100;
          cartQuantity += item.quantity;
        }
        if (item.properties && item.properties.campaign == campaign.name) {
          giftInCart = item.variant_id;
          giftQtyInCart += item.quantity;
        }
      });

      // calculate gift quantity
      var giftQuantity = 1;
      if (campaign.multiple_gift) {
        var byCartValue = campaign.conditions.min_cart_value > 0 ? Math.floor(cartValue / campaign.conditions.min_cart_value) : -1;
        var byCartQuantity = campaign.conditions.min_cart_quantity > 0 ? Math.floor(cartQuantity / campaign.conditions.min_cart_quantity) : -1;

        giftQuantity = byCartValue > 0 && byCartQuantity > 0 ? Math.min(byCartValue, byCartQuantity) : Math.max(byCartValue, byCartQuantity);
      } else {
        if (campaign.conditions.min_cart_value > 0 && campaign.conditions.min_cart_value > cartValue) giftQuantity = 0;
        if (campaign.conditions.min_cart_quantity > 0 && campaign.conditions.min_cart_quantity > cartQuantity) giftQuantity = 0;
      }
      giftQuantity -= giftQtyInCart;

      // remove gift in cart if not eligible, that's if gift quantity is less than 0
      if (giftQuantity < 0 && giftInCart) {
        var data = { updates: {} };
        data.updates[giftInCart] = 0;
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          })
          .then(function() {
            location.reload();
          })
          .catch(function(_error) {
            console.error(_error);
          });
      }
      if (giftQuantity < 1)  return false;
      campaign.giftQuantity = giftQuantity;
      // update priority
      global_priority = campaign.global_priority;
      group = campaign.group;
      priority = campaign.priority;

      return true;
    });

    Promise.all(campaigns.map(function(campaign) {
        return fetch(`/products/${campaign.gift_product_handle}.js`)
          .then(function(response) {
            return response.json();
          });
      }))
      .then(function(products) {
        campaigns.forEach(function(campaign) {
          var variantData;
          products.forEach(function(product) {
            if (product.handle == campaign.gift_product_handle) {
              if (campaign.gift_variant_id && product.variants.length > 0) {
                variantData = product.variants.find(function(variant) {
                  return campaign.gift_variant_id == variant.id;
                });
              }
              if (!variantData) {
                variantData = product.variants[0];
              }
              if (campaign.auto_add) {
                np.popup.show('', 'Adding gift to your cart...');
                np.deal.addGiftToCart(campaign, variantData);
              } else {
                if (variantData.available) {
                  var blk = giftBlock.cloneNode(true);

                  blk.querySelector('.gift-offer_message').textContent = campaign.offer_message;
                  blk.querySelector('.gift-offer_option--accept').addEventListener('click', function() {
                    np.deal.addGiftToCart(campaign, variantData);
                  });
                  blk.querySelector('.gift-offer_option--decline').addEventListener('click', function() {
                    blk.remove();
                  });
                  giftBlock.insertAdjacentElement('afterend', blk).style.display = 'block';
                } else {
                  // gift not available
                }
              }
            }
          });
        });
      })
      .catch(function(error) {
        console.error(error);
      });
  },
  applyToProductPage: function() {
    var card = document.querySelector('.card[data-product-id]');
    var infoBlock = document.querySelector('.product-extra-info');

    if (card && infoBlock) {
      var productId = parseInt(card.dataset.productId, 10);

      // loop all deal campaigns
      this.campaigns.forEach(function(campaign) {
        // check is campaign active
        if (!np.deal.isActive(campaign)) return;

        // check product eligibility
        if (!np.deal.isEligible(campaign, productId)) return;

        // check if ok to show
        if (!campaign.show_on_product_page) return;

        infoBlock.innerHTML = `<div><p><strong>${campaign.name}</strong></p><p style="color: var(--secondary-button-background)">${campaign.description}</p></div>${infoBlock.innerHTML}`;
      });
    }
  },
  applyToPage: function() {
    var content = document.querySelector('.page__content');

    if (location.pathname == '/pages/deals' && content) {
      var dateTimeFormat = new Intl.DateTimeFormat('en-GB', {
        dateStyle: 'full',
        timeStyle: 'medium'
      });
      np.deal.campaigns.forEach(function(campaign) {
        // check is campaign active
        if (!np.deal.isActive(campaign)) return;

        var startDate = dateTimeFormat.format(new Date(campaign.start_date + '.000+12:00'));
        var endDate = dateTimeFormat.format(new Date(campaign.end_date + '.000+12:00'));
        var description = campaign.description;
        if (campaign.disclaimer) {
          description += ' ' + campaign.disclaimer
        }

        content.innerHTML += `
          <div class="deals__campaign">
            <h4 class="deals__campaign__name">${campaign.name}</h4>
            <p class="deals__campaign__description">${description}</p>
            <p class="deals__campaign__date">Valid from <span class="deals__campaign__date--start">${startDate}</span> to <span class="deals__campaign__date--end">${endDate}</span> or while stocks last.</p>
          </div>
        `;
      });
    }
  }
};

/*************************
Practitioner
*************************/
np.practitioner = {
  signupForm: function() {
    // Practitioner Ranges Access page
    var practitionerForm = document.querySelector('.practitionerForm');
    if (practitionerForm && ShopifyAnalytics.meta.page.customerId) {
      practitionerForm.querySelector('.notice').style.display = 'none';
      practitionerForm.querySelector('.acerill-custom-form').style.display = 'block';
    }
  }
};

/*************************
Cart page
*************************/
np.cart = {
  init: function() {
    // override submit action, need to check if logged in when a certain products are in cart
    // override submit action, need to check if terms & conditions checkbox is checked or not
    // attach event to document to capture all form submission, the cart form gets replaced if customers edited cart
    var loginRequired = document.querySelectorAll('.cart-recap__login');
    var terms = document.querySelectorAll('section[data-section-type="cart"] input[name="terms"]');

    loginRequired.addEventListener('click', function() {
      location.href = '/account/login';
    });

    terms.addEventListener('change', function(e) {
      terms.forEach(function(term) {
        if (!term.isEqualNode(e.currentTarget)) {
          term.checked = e.currentTarget.checked;
        }
      });
    });

    document.querySelector('#cart-form').addEventListener('submit', function(e) {
      var checkedTerms = document.querySelectorAll('section[data-section-type="cart"] input[name="terms"]:checked');
      if (loginRequired.length > 0 || checkedTerms.length === 0) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        e.preventDefault();

        if (loginRequired.length > 0) {
          // redirect to login page
          location.href = '/account/login';
        } else if (checkedTerms.length === 0) {
          // remind users terms not checked
          // remove required attribute for mobile terms checkbox if it's no longer visible so second checkbox can be shown when report validity
          var termsMobile = document.querySelector('#termsOfUse--mobile');
          if (termsMobile.getClientRects().length === 0 || termsMobile.getBoundingClientRect().top < 120) {
            termsMobile.required = false;
          }

          e.currentTarget.reportValidity();
          termsMobile.required = true;
        }
      } else {
        // proceed to checkout
        // dispatch custom event
        document.dispatchEvent(new Event('begin_checkout'));
      }
    });
  },
  qtyInCart: function(variantId) {
    var qty = 0;

    this.items.forEach(function(item) {
      if (variantId == item.variant_id) {
        qty += item.quantity;
      }
    });

    return qty;
  },
  update: function(variantId, qty) {
    this.items.forEach(function(item) {
      if (variantId == item.variant_id) {
        item.quantity -= qty;
      }
    });
  }
};

/*************************
Misc.
*************************/
np.popup = {
  modal: null,
  init: function() {
    var template = document.querySelector('template.popup-notice');
    if (template) {
      template.replaceWith(template.content.cloneNode(true));
    }

    this.modal = document.querySelector('.modal--notice');
    this.modal.querySelector('.popup__close').addEventListener('click', this.close.bind(this));
    this.modal.addEventListener('click', function(e) {
      if (!this.modal.contains(e.target) || this.modal === e.target) {
        this.close();
      }
    }.bind(this));
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        this.close();
      }
    }.bind(this));
  },
  show: function(title, content, timeToClose) {
    this.init();

    if (!this.modal || !content) {
      return;
    }

    if (title) {
      this.modal.querySelector('.popup__title').textContent = title.trim();
    }
    this.modal.querySelector('.popup__content').textContent = content.trim();

    if (!Number.isNaN(timeToClose) && timeToClose > 0) {
      setTimeout(this.close.bind(this), timeToClose);
    }

    this.open();
  },
  open: function() {
    this.modal.setAttribute('aria-hidden', 'false');
  },
  close: function() {
    this.modal.setAttribute('aria-hidden', 'true');
  }
};

/*************************
DOM ready event
*************************/
window.addEventListener('DOMContentLoaded', function() {
  // load on all pages
  // load cart data
  fetch('/cart.js')
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      np.cart.items = data.items;
      np.product.maxQty.init();
      if (location.pathname.startsWith('/cart')) {
        np.deal.applyToCart();
      }
    })
    .catch(function(error) {
      console.error(error);
    });

  np.product.parse(document);
  np.deal.init();

  // if item is removed from mini cart / cart page
  document.addEventListener('click', function(e) {
    if (e.target.matches('[data-max-quantity] a[class*="__quantity-remove"]')) {
      document.addEventListener('theme:loading:end', function() {
        np.product.maxQty.restore(e.target.closest('[data-max-quantity]'));
      }, {
        once: true
      });
    }
  });

  // remove URL parameters appended by Shopify Search
  cleanSearch();

  // determine pages
  if (location.pathname.includes('/products/')) {
    // product page
    np.product.consultationForm.init();
    np.practitioner.signupForm();
    np.deal.applyToProductPage();

    // update variant description on load
    var selected_variant = document.querySelector('.product-form__selected-value');
    if (selected_variant) {
      selected_variant = selected_variant.textContent.trim();
      document.querySelectorAll('.variant_description').forEach(function(variant_description) {
        variant_description.style.display = 'none';
        if (variant_description.querySelector(`[data-variant="${selected_variant}"]`)) {
          variant_description.style.display = 'block';
        }
      });
    }
  } else if (location.pathname.startsWith('/collections/')) {
    // collection page
    np.product.consultationForm.init();
    // watching on collection page
    var collectionDynamicPart = document.querySelector('.collection__dynamic-part');

    if (collectionDynamicPart) {
      new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length > 0) {
            np.product.parse(collectionDynamicPart);
          }
        });
      }).observe(collectionDynamicPart, {
        subtree: true,
        childList: true
      });
    }
  } else if (location.pathname.startsWith('/pages/')) {
    // pages
    np.practitioner.signupForm();
    np.deal.applyToPage();
  } else if (location.pathname.startsWith('/cart')) {
    // cart page
    np.cart.init();
  } else if (location.pathname.startsWith('/account')) {
    // account page
    // append previous page URL so users are redirected back after login
    if (location.pathname === '/account/login' && document.referrer.includes('netpharmacy.co.nz/') && !document.referrer.endsWith('netpharmacy.co.nz/')) {
      document.querySelector('form#customer_login input[name="return_url"').value = document.referrer;
    }
  }

  // dispatch custom event when every customised stuff is loaded & parsed
  document.dispatchEvent(new Event('DOMContentLoaded:custom'));
});

/*************************
Theme loading event
*************************/
document.addEventListener('theme:loading:end', function() {
  // remove URL parameters appended by Shopify Search
  cleanSearch();
});

/*************************
Cart updated event
*************************/
document.addEventListener('cart:updated', function(e) {
  np.cart.items = e.detail.cart.items;
});

/*************************
Cart product added event
*************************/
document.addEventListener('cart:added', function(e) {
  np.product.maxQty.process(e.detail.item.variant_id, e.detail.item.quantity);
});

/*************************
Cart product removed event
*************************/
document.addEventListener('cart:removed', function(e) {
  np.product.maxQty.process(e.detail.item.variant_id, -Math.abs(e.detail.item.quantity));
});

/*************************
Cart rerendered event
*************************/
document.addEventListener('cart:rerendered', function(e) {
  document.querySelector('.progress_bar').style.width = document.querySelector('.cart-wrapper__inner-inner .container .card').offsetWidth + 'px';
});

/*************************
Product variant change event
*************************/
document.addEventListener('variant:changed', function(e) {
  var options = JSON.parse(document.querySelector('[data-section-type="product"]').dataset.sectionSettings);
  var variant = e.detail.variant; // Gives you access to the whole variant details
  var productBlock = document.querySelector('.card[data-product-id]');

  // update variant ID
  productBlock.dataset.variantId = variant.id;

  // variant description
  document.querySelectorAll('.variant_description').forEach(function(variant_description) {
    variant_description.style.display = 'none';
    if (variant_description.querySelector(`[data-variant="${variant.title}"]`)) {
      variant_description.style.display = 'block';
    }
  });

  // update Afterpay
  document.querySelector('.product-form__price-info.afterpay .afterpay_price').textContent = `$${Math.round(variant.price / 4 + Number.EPSILON) / 100}`;

  // update reward points
  var product = np.product.get();
  var rewardPoints = 0;
  var rewardBlock = document.querySelector('.product-form__reward.points');

  if (product &&
    !product.tags.includes('ExcludeRewards') &&
    !product.tags.includes('Infant Formula') &&
    !product.tags.includes('Pharmacist Only Medicine') &&
    !product.tags.includes('Prescription Medicine') &&
    !product.tags.includes('Pharmacy Only Medicines')) {
    rewardPoints = Math.floor(variant.price / 100 * (window.reward_points_per_dollar || 10));
  }

  rewardBlock.dataset.rewardPoints = rewardPoints;
  rewardBlock.querySelector('span').textContent = rewardPoints;

  // update stock availability
  var inventory = document.querySelector('.product-form__info-item[data-item="inventory"]');

  inventory.toggleAttribute('hidden', !variant.available || variant.inventory_quantity > options.lowInventoryThreshold);
  inventory.querySelector('.product-form__inventory').textContent = `Only ${variant.inventory_quantity} unit${variant.inventory_quantity > 1 ? 's' : ''} left`;

  // update max quantity
  if (product.tags.includes('Quantity Restricted')) {
    product.variants.forEach(function(v) {
      if (variant.id == v.id) {
        productBlock.dataset.maxQuantity = v.maxQuantity;
        productBlock.querySelector('.product-extra-info__quantity-restriction .max-quantity').textContent = v.maxQuantity;
        productBlock.removeAttribute('data-allowance');
      }
    });
  }
})

/*************************
Product added event
*************************/
document.addEventListener('product:added', function(e) {
  var variantId = e.detail.variant.id;
  if (e.detail.variant.formId) {
    variantId = document.querySelector(`#${e.detail.variant.formId} input[name="id"]`).value;
  }
  np.product.maxQty.process(variantId, e.detail.quantity);
});

/*************************
document.body mutation event
*************************/
new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(addedNode) {
      if (!(addedNode instanceof Element)) return;
      // watch added cart form after cart item quantity update then apply deal campaigns to cart
      if (addedNode.matches('.cart-wrapper')) {
        np.cart.init();
        np.deal.applyToCart();
      }

      // parse product data from lazy loaded flickity
      if (addedNode.classList.contains('flickity-viewport')) {
        np.product.parse(addedNode);
      }

      // init quantity restriction, only fires when cart ajax call is finished
      if (np.cart.hasOwnProperty('items')) {
        np.product.maxQty.init();
      }
    });
  });
}).observe(document.body, {
  subtree: true,
  childList: true
});
